import {
  endOfDay, startOfDay,
  subDays,
  startOfWeek,
  endOfWeek,
  addDays,
  startOfMonth,
  endOfMonth,
  addMonths,
} from "date-fns";
import moment from "moment";

export const downloadXl = (file) => {
  // using Java Script method to get PDF file
  // const fileURL = file.replace('http://', 'https://');
  if(!file){ // fi file ur is empty or null or the ndefined
    return 
  }
  const fileURL = file.startsWith('http://') ? file.replace('http://', 'https://') : file;
  // Setting various property values
  let alink = document.createElement('a');
  alink.href = fileURL;
  alink.download = 'UserReport.xlsx';
  alink.target = '_blank';
  alink.click();
}


export function changeDateFormat(originalDate) {
  const parts = originalDate.split('-');
  return `${parts[1]}/${parts[2]}/${parts[0]}`;
}


export function downloadFile(url) {
  fetch(url)
    .then(async response => {
      const contentDisposition = response.headers.get('Content-Disposition');
      const filename = contentDisposition ? contentDisposition.split('filename=')[1] : 'job-monitor';

      return response.blob().then(blob => {
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.setAttribute('download', filename);

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });
    })
    .catch(error => {
      console.error('Error downloading file:', error);
    });
}

export const downloadXlMonthly = async (file) => {
  // Ensure the URL uses HTTPS
  const fileURL = file.startsWith('http://') ? file.replace('http://', 'https://') : file;

  // Extract the file name from the URL and replace underscores with spaces
  let fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1) || 'UserReport.xlsx';
  fileName = fileName.split('?')[0]; ;

  try {
    // Fetch the file content
    const response = await fetch(fileURL);
    const blob = await response.blob();

    // Create a link and set the URL and download attributes
    const alink = document.createElement('a');
    const downloadURL = URL.createObjectURL(blob);
    alink.href = downloadURL;
    alink.download = fileName;
    alink.target = '_blank';
    alink.click();

    // Clean up the URL object
    URL.revokeObjectURL(downloadURL);
  } catch (error) {
    console.error('Error downloading the file:', error);
  }
}


export const changeAllTitleFunction = (linkText, linkUrl) => {

}

export const checkDbkValidation = (value1, dbk_value1, is_permission, type = "text") => {
  let value = value1 == null ? "" : value1
  let dbk_value = dbk_value1 == null ? "" : dbk_value1
  let is_valid = false

  if (is_permission) {
    if (type === "text" && String(value).toUpperCase() != String(dbk_value).toUpperCase()) {
      is_valid = true
    } else if (type === "number" && String(value).replace(NaN, "") != String(dbk_value).replace(NaN, "")) {
      is_valid = true
    } else if (type === "date" && value?.replace("__/__/____", "") !=
      dbk_value?.replace("__/__/____", "")) {
      is_valid = true
    }
  }
  return is_valid
}

export const disableBasedOnSubJob = (subJobEobContainer) => {
  if (subJobEobContainer) {

    const inputs = subJobEobContainer.getElementsByTagName("input");
    const selects = subJobEobContainer.getElementsByTagName("select");


    for (var i = 0; i < inputs.length; i++) {
      inputs[i].disabled = true;
    }

    for (var i = 0; i < selects.length; i++) {
      selects[i].disabled = true;
    }



  }
}

export function disablingBasedOnDbk(container) {
  if (container) {
    const inputs = container.querySelectorAll("input");
    const buttons = container.getElementsByTagName("button");
    const selects = container.getElementsByTagName("select");
    // Disable input elements
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].disabled = true;
    }

    // Disable buttons
    for (let i = 0; i < buttons.length; i++) {
      if (!buttons[i].closest('.exclude-disabled-new')) {
        buttons[i].disabled = true;
      }
    }

    // Disable select elements
    for (let i = 0; i < selects.length; i++) {
      selects[i].disabled = true;
    }

  }
}

export function isActiveDbkField(obj, formik, isFieldPermission) {

  let isActive = Object.values(obj).some(val => val === true) ||
    obj?.claims?.some(claim => Object.values(claim).some(val => val === true));


  let isError = Object.values(formik?.errors).some(val => val === 'Dont Match') ||

    formik?.errors && formik?.errors?.claims && formik?.errors?.claims?.some(claim => claim ? Object.values(claim)?.some(val => val === 'Dont Match') : false);

  return isActive && isError
}



export const predefinedBottomRanges = [
  {
    label: 'Today',
    value: [startOfDay(new Date().setHours(0, 0, 0, 0)), new Date().setHours(23, 59, 59, 59)],
    placement: 'left'
  },
  {
    label: 'Yesterday',
    value: [startOfDay(addDays(new Date(), -1)), endOfDay(addDays(new Date(), -1))],
    placement: 'left'
  },
  {
    label: 'This week',
    value: [startOfWeek(new Date().setHours(0, 0, 0, 0)), endOfWeek(new Date().setHours(23, 59, 59, 59))],
    placement: 'left'
  },
  {
    label: 'Last 7 days',
    value: [startOfDay(subDays(new Date().setHours(0, 0, 0, 0), 6)), new Date().setHours(23, 59, 59, 59)],
    placement: 'left'
  },
  {
    label: 'Last 30 days',
    value: [startOfDay(subDays(new Date().setHours(0, 0, 0, 0), 29)), new Date().setHours(23, 59, 59, 59)],
    placement: 'left'
  },
  {
    label: 'This month',
    value: [startOfMonth(new Date().setHours(0, 0, 0, 0)), new Date().setHours(23, 59, 59, 59)],
    placement: 'left'
  },
  {
    label: 'Last month',
    value: [startOfMonth(addMonths(new Date().setHours(0, 0, 0, 0), -1)), endOfMonth(addMonths(new Date().setHours(23, 59, 59, 59), -1))],
    placement: 'left'
  },
  {
    label: 'This year',
    value: [new Date(new Date().getFullYear(), 0, 1).setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)],
    placement: 'left'
  },
  {
    label: 'Last year',
    value: [new Date(new Date().getFullYear() - 1, 0, 1).setHours(0, 0, 0, 0), endOfDay(new Date(new Date().getFullYear(), 0, 0).setHours(23, 59, 59, 59))],
    placement: 'left'
  },

  // {
  //   label: 'Last week',
  //   closeOverlay: false,
  //   value: value => {
  //     const [start = new Date()] = value || [];
  //     return [
  //       addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
  //       addDays(endOfWeek(start, { weekStartsOn: 0 }), -7)
  //     ];
  //   },
  //   appearance: 'default'
  // },
  // {
  //   label: 'Next week',
  //   closeOverlay: false,
  //   value: value => {
  //     const [start = new Date()] = value || [];
  //     return [
  //       addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
  //       addDays(endOfWeek(start, { weekStartsOn: 0 }), 7)
  //     ];
  //   },
  //   appearance: 'default'
  // }
];
//data-entry
export const DATA_ENTRY = "/my-work"
export const QA_REVIEW = "/qa-review"
export const EDIT_WORK = "/my-work/edit/"
export const DASHBOARD = ""


export const convertDateToStr = (value, is_time = false) => {
  let date = "";
  if (value?.length > 0) {
    const startDate = value[0];
    const endDate = value[1];

    const isGreater = startDate > endDate;

    const format = is_time ? 'MM/DD/YYYY HH:mm:ss' : 'MM/DD/YYYY';

    const dateFrom = moment(isGreater ? endDate : startDate).format(format);
    const dateTo = moment(isGreater ? startDate : endDate).format(format);

    date = `${dateFrom} - ${dateTo}`;
  }

  return date;
};
